import {dynamic} from '@github-ui/dynamic'

export const IssueShowPage = dynamic(async () => {
  const module = await import('./pages/IssueShowPage')
  return {default: module.IssueShowPage}
})

export const IssueViewsPage = dynamic(async () => {
  const module = await import('./pages/IssueViewsPage')
  return {default: module.IssueViewsPage}
})

export const RepositorySavedViewPage = dynamic(async () => {
  const module = await import('./pages/views-show/RepositorySavedViewPage')
  return {default: module.RepositorySavedViewPage}
})

export const RepositoryViewNewPage = dynamic(async () => {
  const module = await import('./pages/views-new/RepositoryViewNewPage')
  return {default: module.RepositoryViewNewPage}
})

// Milestone pages
export const RepositoryMilestonePage = dynamic(async () => {
  const module = await import('./pages/RepositoryMilestonePage')
  return {default: module.RepositoryMilestonePage}
})

// Projects pages
export const RepositoryProjectsPage = dynamic(async () => {
  const module = await import('./pages/RepositoryProjectsPage')
  return {default: module.RepositoryProjectsPage}
})
